import { defineMessage } from 'react-intl';
import { getDisplayInformation } from './get-display-information';

const unknownFulfillmentProvider = defineMessage({
  description: 'dataDrivenLogos.unknownFulfillmentProvider',
  defaultMessage: 'Unknown FulfillmentProvider',
  id: 'Ntl3Qs',
});

export const getFulfillmentProviderDisplayName = (fillProviderId) => {
  const displayInformation =
    getDisplayInformation({
      fillProviderId: Number.parseInt(fillProviderId, 10),
    }) || {};
  if (displayInformation.name) {
    // Return inline message descriptor to avoid formatjs/no-useless-message lint error
    return { id: 'fulfillmentProvider.dynamic', defaultMessage: displayInformation.name };
  }
  return unknownFulfillmentProvider;
};
